import React, { useEffect, useState } from 'react'

import { arrNum } from '../../utils/functions';
import Tooltip from '../atoms/Tooltip';


function Input({
  type,
  label,
  img_label,
  placeholder,
  termsText,
  termsLink,
  privacyText,
  privacyLink,
  onChange,
  value,
  error,
  inputByCharacter,
  maxlength,
  tooltip
}) {
  const [separatedInputs, setSeparatedInputs] = useState([])
  const [dateValue, setDateValue] = useState('')
  const [showPlaceholder, setShowPlaceholder] = useState(true)

  const handleDateChange = (e) => {
    setDateValue(e.target.value)
    setShowPlaceholder(!e.target.value)
    onChange(e) // tu función onChange original
  }

  const onChangeSeparated = async (props) => {
    const index = Number(props.target.getAttribute('rel'))
    const cur = JSON.parse(JSON.stringify(separatedInputs))
    const newC = cur.map((item, i) => i == index ? props.target.value : item)
    setSeparatedInputs(newC)
  }

  const useDeviceDetect = () => {
    const isAndroid = /Android/i.test(navigator.userAgent)
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    return { isMobile: isAndroid || isIOS }
  }

  const { isMobile } = useDeviceDetect();

  const onInputSeparated = async (props) => {

    if (props.target.nextElementSibling) {
      props.target.nextElementSibling.focus()
    }
  }

  useEffect(() => {
    const datePick = document.querySelector('#datePickerId')
    if (datePick) {
      const todayDate = new Date('2007-01-01')
      const limitDate = new Date('1900-01-01')
      datePick.max = new Date(todayDate.setDate(todayDate.getDate() - 1)).toISOString().split("T")[0]
      datePick.min = new Date(limitDate.setDate(limitDate.getDate() - 1)).toISOString().split("T")[0]
    }

    if (inputByCharacter && separatedInputs.length === 0) {

      const arr = []
      for (let i = 0; i < arrNum(maxlength).length; i++) arr.push("")
      setSeparatedInputs(arr)
    }
  }, [])

  return (
    <div className="mc-input-container">
      <div className={`mc-input-container__box ${type} ${error ? 'mc-input-container__box--error' : ''} ${isMobile ? 'isMobile' : ''}`}>
        { img_label 
          ? <label className="mc-input-container__box__label">
              {label}
            </label> 
          : <label>
              {/* {type == 'birthdate' &&
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                  <path d="M2.8443 5.16671C2.8443 4.81309 2.99414 4.47395 3.26086 4.2239C3.52758 3.97385 3.88932 3.83337 4.26652 3.83337H12.7999C13.1771 3.83337 13.5388 3.97385 13.8055 4.2239C14.0722 4.47395 14.2221 4.81309 14.2221 5.16671V13.1667C14.2221 13.5203 14.0722 13.8595 13.8055 14.1095C13.5388 14.3596 13.1771 14.5 12.7999 14.5H4.26652C3.88932 14.5 3.52758 14.3596 3.26086 14.1095C2.99414 13.8595 2.8443 13.5203 2.8443 13.1667V5.16671Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M11.3776 2.5V5.16667" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M5.68909 2.5V5.16667" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2.8443 7.83337H14.2221" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7.82239 11.1667C7.82239 11.3435 7.89731 11.513 8.03067 11.6381C8.16403 11.7631 8.3449 11.8333 8.5335 11.8333C8.7221 11.8333 8.90297 11.7631 9.03633 11.6381C9.16969 11.513 9.24461 11.3435 9.24461 11.1667C9.24461 10.9899 9.16969 10.8203 9.03633 10.6953C8.90297 10.5702 8.7221 10.5 8.5335 10.5C8.3449 10.5 8.16403 10.5702 8.03067 10.6953C7.89731 10.8203 7.82239 10.9899 7.82239 11.1667Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              } */}
              {label}
            </label>
          }
        {img_label && <img src={img_label} alt={label} />}
        {type === 'code' 
          ? inputByCharacter 
            ? <div className='mc-input-separated-container'>
                {arrNum(maxlength).map((i) => {

                  return (
                    <input 
                      key={i}
                      type="text"
                      rel={i}
                      style={{width: `${(100/maxlength)-2}%`}}
                      maxLength={1}
                      onChange={onChangeSeparated}
                      onInput={onInputSeparated}
                      value={separatedInputs[i] ? separatedInputs[i] : ''}
                    />
                  )
                })}
              </div>
            : <div className="mc-input-container__input">
                <input 
                  type="text" 
                  rel={type}
                  placeholder={placeholder}
                  onChange={onChange}
                  value={value}
                />
                {tooltip && 
                  <Tooltip text={tooltip} />
                }
              </div>
          : type === 'document'
            ? inputByCharacter
                ? <div className='mc-input-separated-container'>
                    {arrNum(maxlength).map((i) => {

                      return (
                        <input 
                          key={i}
                          type="text"
                          rel={i}
                          style={{width: `${(100/maxlength)-2}%`}}
                          maxLength={1}
                          onChange={onChangeSeparated}
                          onInput={onInputSeparated}
                          value={separatedInputs[i] ? separatedInputs[i] : ''}
                        />
                      )
                    })}
                  </div>
                : <input 
                    type="text" 
                    rel={type}
                    placeholder={placeholder}
                    onChange={onChange}
                    value={value}
                  />
            : type === 'birthdate'
              ? <div style={{ position: 'relative' }}>
                  {showPlaceholder && isMobile && (
                    <span className='span_placeholder'>
                      {placeholder}
                    </span>
                  )}
                  <input
                    type="date"
                    id="datePickerId"
                    rel={type}
                    onChange={handleDateChange}
                    value={dateValue}
                    style={{ color: showPlaceholder && isMobile ? 'transparent' : '#707070' }}
                  />
                </div>
              : type === 'terms'
                ? <>
                    <a href={termsLink} rel="noreferrer">{termsText}</a>
                    <input 
                      type="checkbox"
                      rel={type}
                      onChange={onChange}
                      checked={value}
                    />
                    <span className="mc-input-checkbox__checkmark"></span>
                  </>
                : type === 'privacy'
                ? <>
                    <a href={privacyLink} rel="noreferrer">{privacyText}</a>
                    <input 
                      type="checkbox"
                      rel={type}
                      onChange={onChange}
                      checked={value}
                    />
                    <span className="mc-input-checkbox__checkmark"></span>
                  </>
                : type === 'textarea' ?
                  <textarea 
                      placeholder={placeholder}
                      onChange={onChange}
                      value={value}
                  ></textarea>
                  :
                  type === 'emailPhone' &&
                  <input 
                      type="text"
                      rel={type}
                      placeholder={placeholder}
                      onChange={onChange}
                      value={value}
                    />

                  

        } 

        {error &&
          <div className="mc-input-error">{error}</div>
        }
      </div>
    </div>
  )
}

export default Input